module.exports = __webpack_public_path__ + "img/logo-m60.b5835f37.png";